/** Admin / form: "1960-1975" → aralık; "1960, 1965" → tek tek yıllar */
export function parseProductionYearsInput(input: string): number[] {
  const raw = (input || '').trim();
  if (!raw) return [];

  const parts = raw
    .split(/[,\n]/g)
    .map((s) => s.trim())
    .filter(Boolean);

  const years: number[] = [];

  for (const part of parts) {
    const rangeMatch = part.match(/^(\d{4})\s*[-–—]\s*(\d{4})$/);
    if (rangeMatch) {
      let from = parseInt(rangeMatch[1], 10);
      let to = parseInt(rangeMatch[2], 10);
      if (!Number.isFinite(from) || !Number.isFinite(to)) continue;
      if (from > to) [from, to] = [to, from];
      const span = to - from + 1;
      if (span > 120) continue;
      for (let y = from; y <= to; y++) years.push(y);
      continue;
    }

    const n = Number(part);
    if (Number.isFinite(n)) years.push(Math.trunc(n));
  }

  return Array.from(new Set(years)).sort((a, b) => a - b);
}

/** Üretim yılları listesinden nesil aralığı (model_key için) */
export function productionYearBounds(years: number[]): {
  yearFrom: number | null;
  yearTo: number | null;
} {
  if (!years.length) return { yearFrom: null, yearTo: null };
  return { yearFrom: Math.min(...years), yearTo: Math.max(...years) };
}

/** Admin formunda gösterim — ardışık yılları 1985-1990 biçiminde birleştirir */
export function formatProductionYearsForInput(
  years?: number[] | null,
  yearFrom?: number | null,
  yearTo?: number | null,
): string {
  if (years?.length) {
    const sorted = [...years].sort((a, b) => a - b);
    if (sorted.length === 1) return String(sorted[0]);
    const contiguous = sorted.every((y, i) => i === 0 || y === sorted[i - 1] + 1);
    if (contiguous) return `${sorted[0]}-${sorted[sorted.length - 1]}`;
    return sorted.join(', ');
  }
  if (yearFrom != null && yearTo != null && yearFrom !== yearTo) return `${yearFrom}-${yearTo}`;
  if (yearFrom != null) return String(yearFrom);
  return '';
}
